import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LoadingButton from '@mui/lab/LoadingButton';
import { useDispatch, useSelector } from 'react-redux';

import { formatDateLabel } from '../../../../../lib/dayjs';
import { EScheduleSteps, updateScheduleSteps } from '../../../../../features/schedule/schedule-slice';
import { RootState } from '../../../../../store';
import { Divider } from '../../../Divider';
import { DialogContent } from '../../styled';
import { useScheduleExameConfirmationMutation } from '../../../../../services/schedule.service';
import { changeScheduleAppointment, clearCalendarSelected } from '../../../../../features/calendar/calendar-slice';
import { ScheduleAnalyticsTrackerInstance } from '../../../../../lib/gtm';

const ScheduleExam = () => {
  const {
    schedule: { dateStart, dateStartISO },
    calendar: {
      calendarSelected,
      isReSchedule,
      journey: { journeyid, product }
    }
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [scheduleExameConfirmation, { isLoading }] = useScheduleExameConfirmationMutation();
  return (
    <>
      <DialogContent>
        <Typography>Depois de agendar, você ainda poderá alterar a data da consulta.</Typography>
        <Divider />
        <Typography variant="body1B" sx={{ mb: 1 }}>
          Data da consulta online
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{formatDateLabel(dateStart)}</Typography>
          <Button
            variant="inline"
            disabled={isLoading}
            onClick={() => {
              dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.openCalendar }));
              dispatch(changeScheduleAppointment({ isReSchedule }));
            }}
          >
            Alterar
          </Button>
        </Box>
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <LoadingButton
          loading={isLoading}
          variant="contained"
          onClick={() => {
            scheduleExameConfirmation({
              calendarid: calendarSelected?.id as string,
              journeyid,
              dateStart: dateStartISO,
              timezone: '-3'
            })
              .unwrap()
              .then(() => {
                ScheduleAnalyticsTrackerInstance.setProperties({
                  scheduleFlow: 'schedule',
                  scheduleDateStart: dateStart || '',
                  scheduleCalendarId: calendarSelected?.id || '',
                  scheduleCalendarAlias: calendarSelected?.alias || '',
                  journeyId: journeyid || '',
                  scheduleProductId: product?.id || ''
                }).sendGAEvent();
                dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.sendFile, previousStep: EScheduleSteps.idle }));
                dispatch(clearCalendarSelected());
              })
              .catch(error => {
                console.log(error);
              });
          }}
          endIcon={<ArrowForwardIcon />}
        >
          Salvar
        </LoadingButton>
      </Box>
    </>
  );
};

export default ScheduleExam;
